import { useState } from 'react';

interface GClassPopupProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function GClassPopup({ isOpen, onClose }: GClassPopupProps) {
  const [showScheduler, setShowScheduler] = useState(false);

  if (!isOpen) return null;

  const handleScheduleTestDrive = () => {
    setShowScheduler(true);
  };

  const handleCloseScheduler = () => {
    setShowScheduler(false);
  };

  return (
    <div className="fixed inset-0 bg-black/90 z-50 overflow-y-auto">
      <div className="min-h-screen px-6 py-12">
        <div className="max-w-5xl mx-auto">
          <div className="flex items-center justify-between mb-8">
            <h2 className="text-4xl md:text-5xl font-bold text-white">
              G-Class <span className="text-amber-400">Collection</span>
            </h2>
            <button
              onClick={onClose}
              className="w-12 h-12 flex items-center justify-center bg-zinc-800 hover:bg-zinc-700 rounded-full transition-colors cursor-pointer"
            >
              <i className="ri-close-line text-white text-2xl"></i>
            </button>
          </div>

          <div className="bg-zinc-800 rounded-2xl overflow-hidden shadow-2xl mb-8">
            <div className="relative h-96 w-full overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/c9e876d11627c32c670d19b2fe0ed4f6.jpg"
                alt="G-Class Collection"
                className="w-full h-full object-cover object-center"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-zinc-900 via-transparent to-transparent"></div>
            </div>
            
            <div className="p-8 md:p-12">
              <div className="mb-8">
                <h3 className="text-3xl font-bold text-white mb-4">
                  The G-Wagon Capital
                </h3>
                <p className="text-gray-300 text-lg leading-relaxed mb-6">
                  Welcome to the largest G-Wagon inventory on the market. We proudly maintain the most extensive selection of Mercedes-Benz G-Class vehicles, earning our reputation as the effective G-Wagon capital.
                </p>
                <p className="text-gray-300 text-lg leading-relaxed">
                  Whether you're seeking the iconic G 550, the high-performance AMG G 63, or exclusive special editions, our wide availability ensures you'll find your perfect G-Class. From classic configurations to the latest innovations, we offer unmatched access to this legendary SUV.
                </p>
              </div>

              <div className="grid md:grid-cols-3 gap-6 mb-8">
                <div className="bg-zinc-900 p-6 rounded-lg">
                  <div className="w-12 h-12 flex items-center justify-center bg-amber-400/10 rounded-lg mb-4">
                    <i className="ri-car-line text-amber-400 text-2xl"></i>
                  </div>
                  <h4 className="text-white font-bold text-lg mb-2">Largest Selection</h4>
                  <p className="text-gray-400 text-sm">Access to the most extensive G-Class inventory available</p>
                </div>
                <div className="bg-zinc-900 p-6 rounded-lg">
                  <div className="w-12 h-12 flex items-center justify-center bg-amber-400/10 rounded-lg mb-4">
                    <i className="ri-star-line text-amber-400 text-2xl"></i>
                  </div>
                  <h4 className="text-white font-bold text-lg mb-2">All Configurations</h4>
                  <p className="text-gray-400 text-sm">G 550, AMG G 63, and exclusive special editions</p>
                </div>
                <div className="bg-zinc-900 p-6 rounded-lg">
                  <div className="w-12 h-12 flex items-center justify-center bg-amber-400/10 rounded-lg mb-4">
                    <i className="ri-shield-check-line text-amber-400 text-2xl"></i>
                  </div>
                  <h4 className="text-white font-bold text-lg mb-2">Immediate Availability</h4>
                  <p className="text-gray-400 text-sm">Wide selection ready for delivery or custom order</p>
                </div>
              </div>

              <button 
                onClick={handleScheduleTestDrive}
                className="w-full bg-amber-400 text-black font-bold py-4 rounded-lg hover:bg-amber-500 transition-colors duration-300 whitespace-nowrap cursor-pointer"
              >
                Let's find your next G-Class!
              </button>
            </div>
          </div>
        </div>
      </div>

      {showScheduler && (
        <div className="fixed inset-0 bg-black/95 z-[60] overflow-y-auto">
          <div className="min-h-screen px-6 py-12">
            <div className="max-w-6xl mx-auto">
              <div className="flex items-center justify-between mb-8">
                <h2 className="text-3xl md:text-4xl font-bold text-white">
                  Schedule Your <span className="text-amber-400">Appointment</span>
                </h2>
                <button
                  onClick={handleCloseScheduler}
                  className="w-12 h-12 flex items-center justify-center bg-zinc-800 hover:bg-zinc-700 rounded-full transition-colors cursor-pointer"
                >
                  <i className="ri-close-line text-white text-2xl"></i>
                </button>
              </div>

              <div className="bg-zinc-900 rounded-lg shadow-2xl overflow-hidden">
                <div className="aspect-[16/9] w-full">
                  <iframe
                    src="https://mercedeswithjacob.square.site/"
                    className="w-full h-full"
                    style={{ minHeight: '600px' }}
                    title="Schedule Appointment"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
